import ArticulosScreen from './containers/articulosScreen'

export {default as ArticulosScreenLayout} from './components/articulosScreenLayout'

export default ArticulosScreen
